import React from 'react';
import { useEffect, useState, useRef } from "react";
import styled from 'styled-components';
import NavButton from '../../homepage/header-banner/TopNavButton';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import CardWrap from '../../microservice/components/CardWrapper';
// import config from '../components/config';
import Sidebar from '../../container/Sidebar/Sidebar';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';


const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;


// Titlecloudcompute
function WebHookVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Webhook - Serverless Application - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className='main-body'>
                <Row>
                    <Col lg={3} md={12} xs={12}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col lg={9} md={12} xs={12} className="right-content">
                        {/* {Titlecloudcompute("Webhook")} */}
                        <BoxContent>
                            <BoxText  ><p class="typo-14">• Webhook là thông báo sự kiện được gửi trực tiếp đến URL do người dùng chọn.</p></BoxText>
                            <BoxText  ><p class="typo-14">• Người dùng kích hoạt Event trên một trang web và gọi chương trình thực thi trên trang khác.</p></BoxText>
                            <BoxText  ><p class="typo-14">• Trong môi trường phát triển microservice, dễ dàng cấu hình các công việc liên quan giữa các ứng dụng nhỏ hoặc ứng dụng bên ngoài, giúp rút ngắn thời gian phát triển là tính năng cần thiết.</p></BoxText>
                            {/* {Imagecloudcompute("https://hanbiro.com/cloud/library2/webhook/webhook-1.svg")} */}
                            <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/webhook-1.png"></ImageWrap>
                            <BoxText ><p class="typo-14">Khi xuất phát một sự kiện cụ thể từ bên ngoài, gọi đến client (API ngược lại)</p></BoxText>
                            <BoxText ><p class="typo-14">URL được client gọi tới, URL gửi dữ liệu gọi là Callback URL</p></BoxText>
                            <BoxText ><p class="typo-14">Ý nghĩa của Hooking: Thêm hành động trước hoặc sau một hành động nào đó</p></BoxText>
                        </BoxContent>
                        <DividerComponent />
                        {/*
                        {CardWrap("• 가격",config.tb6_header,config.tb6_content)}
                        */}
                        <BoxContent>
                            <BoxText ><p class="typo-21-sm typo-medium typo-black">Webhook của AWS</p></BoxText>
                            <ImageWrap src="https://hanbiro.com/cloud/library2/webhook/webhook-2.svg"></ImageWrap>
                        </BoxContent>


                        {/* {CardWrap(
                            "<p>• AWS 의 Webhook</p>",
                            "", 
                            "", 
                            "https://hanbiro.com/cloud/library2/webhook/webhook-2.svg"
                        )} */}

                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>


            <FooterVn />
        </Sysfont>
    );
};

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px; 
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
`

const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`

export default WebHookVN;